var _defs, _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGrayedGroup = function SvgGrayedGroup(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 20.923 16",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{clip-path:url(#a);}.c{fill:#C1CACF;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 20.923,
    height: 16
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M192.038,147.635a3.692,3.692,0,0,0,0-7.385c-.369,0-.738.123-1.108.123a6.3,6.3,0,0,1,0,7.138C191.3,147.512,191.669,147.635,192.038,147.635Zm-6.154,0a3.692,3.692,0,1,0-3.692-3.692A3.626,3.626,0,0,0,185.885,147.635Zm8.123,2.708a4.7,4.7,0,0,1,1.723,3.446v2.462h3.692v-2.462C199.423,151.942,196.469,150.712,194.008,150.342Zm-8.123-.246c-2.462,0-7.385,1.231-7.385,3.692v2.462h14.769v-2.462C193.269,151.327,188.346,150.1,185.885,150.1Z",
    transform: "translate(-178.5 -140.25)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGrayedGroup, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/grayed-group.937d70f1.svg";
export { ForwardRef as ReactComponent };